module.exports = __webpack_public_path__ + "assets/checkCircleFilled-320bb9.svg";